import { Directive, HostListener, Input, inject } from '@angular/core';
import { IButtonAction } from '@partners/ui';
import { ProfileService } from '../../process';
import { TNavAction } from '../model';
import { NavigationAdapter } from '../services';

@Directive({
  selector: '[navigator]',
  standalone: true
})
export class NavigationDirective {
  @Input()
  navigator: TNavAction;

  private _navigationAdapter = inject(NavigationAdapter);
  private _profileService = inject(ProfileService);
  @HostListener('click', ['$event'])
  public onClick({ event, context }: IButtonAction): void {
    event.preventDefault();
    this.navigate();
  }

  constructor() {}

  private navigate() {
    if (this.navigator === 'move-previous') {
      this._navigationAdapter.moveBack();
    } else if (this.navigator === 'move-current') {
      this._navigationAdapter.moveToCurrent();
    } else if (this.navigator === 'move-next') {
      this._navigationAdapter.moveNext();
    } else if (this.navigator === 'exit-failure') {
      this._profileService.terminateProcess('error');
    } else if (this.navigator === 'exit-success') {
      this._profileService.terminateProcess('success');
    } else if (this.navigator === 'exit-opt-out') {
      this._profileService.terminateProcess('customer-opt-out');
    }
  }
}
